import { siteContent } from "@/data/site-content";
import SectionRenderer from "@/components/sections/SectionRenderer";
import Layout from "@/components/layout/Layout";
import { Seo } from "@/components/Seo";

const ORGANIZATION_JSONLD = {
  "@context": "https://schema.org",
  "@type": "NGO",
  name: "Håp Naturlab",
  alternateName: "Håp NaturLab",
  url: "https://www.haap-naturlab.no",
  logo: "https://rvpirrrwpasphlirukef.supabase.co/storage/v1/object/public/brand-images/cbab4041-35cb-43ab-a927-605a6ef2fc6d/logo_onboarding.png",
  description:
    "Veldedig hudpleie-satsning der hele overskuddet går til prosjekter for syke barn. Godkjent av Innsamlingskontrollen.",
  address: {
    "@type": "PostalAddress",
    streetAddress: "Andreas Nilsens vei 19",
    postalCode: "3040",
    addressLocality: "Drammen",
    addressCountry: "NO",
  },
  email: "ines.simic@hotmail.no",
  taxID: "998 463 602",
  sameAs: ["https://www.facebook.com/profile.php?id=61584148410978"],
  potentialAction: {
    "@type": "DonateAction",
    name: "Bli fast giver",
    target: "https://www.haap-naturlab.no/#fastgiver",
    recipient: {
      "@type": "NGO",
      name: "Håp Naturlab",
    },
  },
};

const Index = () => {
  const homePage = siteContent.pages.find((p) => p.slug === "hjem");
  const seo = siteContent.seo["hjem"];

  if (!homePage) return null;

  return (
    <Layout>
      <Seo
        title={seo?.title ?? "Håp Naturlab"}
        description={seo?.description ?? ""}
        jsonLd={ORGANIZATION_JSONLD}
      />
      <SectionRenderer sections={homePage.sections} />
    </Layout>
  );
};

export default Index;
